<template>
  <div>
    <div class="px-3">
      <FilterWrapper>
        <template slot="filterForm">
          <GenericFilter
            :loading="loading"
            :rLoading="rLoading"
            :submitFilter="refetch"
            :clearFilter="() => clearFilter('invoiceRef')"
          />
        </template>
      </FilterWrapper>
    </div>
    <TableWrapper
      :loading="loading"
      :errorMsg="errorMsg"
      :refetch="fetchInvoice"
      :isEmpty="isEmpty"
      :emptyTitle="emptyTitle"
    >
      <div class="w-100 py-3" slot="content">
        <v-server-table
          ref="invoiceRef"
          class="v-table row-pointer"
          :data="customers"
          :columns="columns"
          :options="options"
          @loading="setLoading(true)"
          @loaded="onLoaded"
          @row-click="handleClick"
        >
          <template slot="createdAt" slot-scope="{ row }">
            {{ row.createdAt | moment(" MM-DD-YYYY h:mm a") }}
          </template>
          <div slot="amount" slot-scope="{ row }">
            <span>{{ toCurrency(row.amount, row.currency) }}</span>
          </div>
          <div slot="invoice_link" slot-scope="{ row }">
            <span>{{ invoice_link || "N/A" }}</span>
          </div>
          <div slot="phone" slot-scope="{ row }">
            <span v-if="row.other_info.customer">{{
              row.other_info.customer.phone
            }}</span><span v-else>N/A</span>
          </div>
          <div slot="status" slot-scope="{ row }">
            <span :class="statusColor(row.status)">{{
              titleCase(row.status)
            }}</span>
          </div>
        </v-server-table>
      </div>
    </TableWrapper>
  </div>
</template>

<script>
import { componentData } from "../../../../../public/assets/mixins/componentData";
import TableWrapper from "../../../../components/utils/TableWrapper/TableWrapper.vue";
import GenericFilter from "../../../../components/filters/GenericFilter.vue";

const tableHeadings = {
  invoice_reference: "Invoice Reference",
  amount: "Amount",
  invoice_link: "Invoice Link",
  phone: "Recipient Number",
  createdAt: "Date Created",
  status: "Status",
};

export default {
  name: "Invoice",
  mixins: [componentData],
  data() {
    return {
      singleInviteObj: null,
      showSingleInviteModal: false,
      emptyTitle: "No Invoice Found",
      showInviteModal: false,
      loading: false,
      errorMsg: "",
      customers: [],
      ...this.tableOptions(tableHeadings, 25),
    };
  },
  components: {
    TableWrapper,
    GenericFilter,
  },
  methods: {
    refetch(filters) {
      this.handleRefetch(filters, this.fetchInvoice, "invoiceRef");
    },
    handleClick({ row }) {
      this.$router.push(
        `/invoice-details/${this.clientid}/${row.invoice_reference}`
      );
    },
    async fetchInvoice() {
      this.options.requestFunction = async (data) => {
        const params = {
          ...data,
          ...this.filters,
          id: this.clientid,
          size: 25,
        };
        const response = await this.$store.dispatch(
          "payment/getMerchantInvoice",
          {
            params,
          }
        );

        const newData = response.data.data;
        const count = response.data.total;
        return { ...response, count, total: count, data: newData };
      };
    },
  },

  props: ["clientid"],
  created() {
    this.fetchInvoice();
  },
  mounted() {
    this.columns = Object.keys(tableHeadings).map((keyVal) => keyVal);
  },
};
</script>
